<template>
  <div :class="[state ? 'alert-green' : 'alert-red', 'alert-box']" v-if="alertShow">
    <i class="fa fa-check" aria-hidden="true" v-if="state"></i>
    <i class="fa fa-times" v-if="!state"></i>
    <p>{{msg}}</p>
  </div>
</template>

<script>
export default {
  data () {
    return {
      alertShow: true
    }
  },
  props: {

    msg: {
      type: String,
      default: ''

    },
    state: {
      type: Boolean,
      default: true
    }
  },
  mounted () {
    setTimeout(() => {
      this.alertShow = false
    }, 5000)
  }
}
</script>
<style scoped>
.alert-box{
  font-size: 14px;
  display: flex;
  color: #ffffff;
  position: fixed !important;
  padding: 14px 14px;
  top: 130px !important;
  right: 0px !important;
  z-index: 30000;
  max-width: 300px;
  border-radius: 5px;
}
.alert-box i{
  margin-top: 3px;
  margin-right: 5px;
}
.alert-green {
  background-color: #3fd892;
}
.alert-red {
  background-color: #ce4f4f;
}
</style>



// WEBPACK FOOTER //
// src/common/tip/index.vue